<!--
 * @Author:
 * @Description:交易查询
 * @Date: 2025-01-21 10:00:29
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/transaction/transaction-query/index.vue
-->

<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" class="transaction-search" :search-condition="searchCondition"
        :search-buttons="searchButtonList" :validFunction="validSearchParams"
        :fuzzySearchPlaceholder="fuzzySearchPlaceholder" fuzzy-search-key="keywords" :showMerchantSearch="true"
        :isDisplayReset="true" router-name="/transaction/query">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :service-function="getTransactionList"
        :first-parameters="getInitParams()" ref="table" :is-first-automatic-visit="false" :showMerchantNo="true"
        router-name="/transaction/query">
      </custom-table>
    </div>
    <!-- 退款 -->
    <refund-dialog ref="refundDialogRefState" @refresh="onRefreshTable"></refund-dialog>
    <!-- 上传物流单号 -->
    <validation-modal ref="uploadModal" :titleText="$t('message.transaction.uploadLogisticsNo')" width="750px"
      @refresh="uploadTrackNumberFileSuccessHandler" :validation-condition="uploadCondition"
      :default-function="uploadTrackNumberFile">
    </validation-modal>
    <!-- 批量查询 -->
    <validation-modal ref="uploadBatchQueryModal" :titleText="$t('message.transaction.batchQuery')" width="750px"
      :default-function="uploadBatchQueryFile" :validation-condition="batchQuerydCondition"
      submitSuccessTip="message.common.downloadTask">
    </validation-modal>
    <!-- 批量退款 -->
    <validation-modal ref="uploadBatchRefundModal" :titleText="$t('message.transaction.batchRefund')" width="750px"
      @refresh="uploadTrackNumberFileSuccessHandler" :default-function="uploadBatchRefundFile"
      :validation-condition="batchRefundCondition">
    </validation-modal>
  </div>
</template>
<script>

import { getCardTypeList } from '@/api/common';
import ValidationModal from '@/components/modal/base-modal/validation-modal.vue';
import { ShowWarningMessage, ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { REQUIRED, EMAIL } from '@/components/validation/tool/validator';
import { getCurrentMenu } from '@/layout/base/components/inavbar/utils';
import { IS_PERMISSION_BUTTON } from '@/store/modules/permission';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData, splicingAmountAndCurrency } from '@/utils/tools/constant';
import { getWeekParams, initWeek, initDaysRangeByToday, formatDateDisplay } from '@/utils/tools/time';
import { shallowClones, formatCardNumber } from '@/utils/tools/utils';
import TransitionService from '@/views/transaction/api/transaction-query.service';
import {
  ShowChargebackAlertOptions, TxnCompletedOptions,
  UploadOptions, UserPaymentStatus, QueryHistoryOptions, boolSelect,
} from '@/views/transaction/status/transaction';
import RefundDialog from '@/views/transaction/transaction-details/components/refundDialog/index.vue';

import { TXN_TYPE } from '../../../const/dict/enum';
import { statusList } from '../../../utils/options/common';

export default {
  components: {
    SearchComponent,
    CustomTable,
    ValidationModal,
    RefundDialog,
  },
  data() {
    return {
      ...TransitionService,
      getWeekParams,
      downloading: false,
      txnTypeList: [],
      txnStatusList: [],
      productTypeList: [],
      subProductTypeList: [],
      cardTypeList: [],
      carrierList: [],
      shareStatusList: [],
      statusList,
      txnTypeSelects: [
        TXN_TYPE.SALE,
        TXN_TYPE.AGENCY_PROFIT,
        TXN_TYPE.ADJUSTMENT,
        TXN_TYPE.TAX,
        TXN_TYPE.FEE,
        TXN_TYPE.AUTHORIZATION,
        TXN_TYPE.BIND_CARD,
        TXN_TYPE.PRE_AUTHORIZATION,
        TXN_TYPE.CAPTURE,
        TXN_TYPE.VOID,
      ],
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.txnSerialNumber')};${this.$t('message.tableCommon.originalTxnSerialNumber')};${this.$t('message.tableCommon.merchantOrderNumber')};` +
        `${this.$t('message.tableCommon.merchantOriginalOrderNumber')};${this.$t('message.transaction.channelResponseId')}`,
      searchCondition: [
        {
          key: ['startTime', 'endTime'],
          name: 'message.tableCommon.txnTime',
          defValue: initDaysRangeByToday(-2),
          type: 'date_time',
        },
        // {
        //   key: 'isHistory',
        //   name: 'message.tableCommon.queryHistory',
        //   type: 'select',
        //   defValue: '1',
        //   options: QueryHistoryOptions,
        //   isInternationalization: true,
        // },
        // {
        //   key: 'txnId',
        //   name: 'message.tableCommon.txnSerialNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        // {
        //   key: 'originTxnId',
        //   name: 'message.tableCommon.originalTxnSerialNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        // {
        //   key: 'merchantTxnId',
        //   name: 'message.tableCommon.merchantOrderNumber',
        //   type: 'input',
        //   defValue: '',
        // },
        {
          key: 'website',
          name: 'message.tableCommon.website',
          type: 'input',
          defValue: '',
        },
        {
          key: 'txnStatus',
          name: 'message.tableCommon.txnStatus',
          type: 'select',
          defValue: [''],
          options: this.txnStatusList,
          multiple: true,
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter(item => item !== '');
            }
            this.$refs.search.setInputValue('txnStatus', list);
          },
        },
        {
          key: 'txnType',
          name: 'message.tableCommon.txnType',
          type: 'select',
          multiple: true,
          defValue: [''],
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter(item => item !== '');
            }
            this.$refs.search.setInputValue('txnType', list);
          },
        },
        {
          key: 'productType',
          name: 'message.tableCommon.productType',
          type: 'select',
          defValue: '',
        },
        {
          key: 'subProductType',
          name: 'message.tableCommon.subProductType',
          type: 'select',
          defValue: '',
        },
        {
          key: 'cardType',
          name: 'message.tableCommon.cardType',
          type: 'select',
          defValue: '',
          options: this.cardTypeList,
        },
        {
          key: ['beforeCardNum', 'afterCardNum'],
          name: 'message.tableCommon.bankCardNo',
          type: 'input_range_two',
          inputRange: {
            placeholders: ['message.common.first6Digits', 'message.common.last4Digits'],
            strLength: [6, 4],
          },
        },
        {
          key: 'email',
          name: 'message.tableCommon.email',
          type: 'input',
          defValue: '',
        },
        {
          key: 'require3d',
          name: 'message.tableCommon.require3d',
          type: 'select',
          placeholder: 'message.searchCommon.all',
          options: boolSelect,
          defValue: '',
          isInternationalization: true,

        },
        {
          key: 'chargebackWarning',
          name: 'message.refuse.chargebackAlert',
          type: 'select',
          defValue: '',
          options: ShowChargebackAlertOptions,
          isInternationalization: true,
        },
        {
          key: 'completed',
          name: 'message.tableCommon.isCompleted',
          type: 'select',
          defValue: '',
          options: TxnCompletedOptions,
          isInternationalization: true,
        },
        {
          key: 'walletTypeCode',
          name: 'message.tableCommon.subCardType',
          type: 'select',
          defValue: '',
          options: [],
        },
        { // 是否上传物流
          key: 'uploaded',
          name: 'message.transaction.isUploadLogistics',
          type: 'select',
          defValue: '',
          options: UploadOptions,
          isInternationalization: true,
        },
        { // 物流单号
          key: 'trackingNumber',
          name: 'message.transaction.logisticsNo',
          type: 'input',
          defValue: '',
          isInternationalization: true,
        },
        {
          key: 'userPaymentStatus',
          name: 'message.transaction.paymentStatus',
          type: 'select',
          defValue: '',
          options: UserPaymentStatus,
          isInternationalization: true,
        },
        { // 分账状态
          key: 'shareStatus',
          name: 'message.transaction.dividendStatus',
          type: 'select',
          defValue: '',
          options: [],
          isInternationalization: true,
        },
        // { // 商户订单号
        //   key: 'merchantTxnId',
        //   name: 'message.tableCommon.merchantOrderNumber',
        //   type: 'input',
        //   defValue: '',
        //   isInternationalization: true,
        // },
        { // 重试交易
          key: 'transSceneFlag',
          placeholder: 'message.searchCommon.all',
          name: 'message.transaction.retryTransaction',
          type: 'select',
          defValue: '',
          options: statusList,
          isInternationalization: true,
        },
        {
          key: 'channelRequestId',
          name: 'message.transaction.channelRequestId',
          type: 'input',
          defValue: '',
        },
      ],
      searchButtonList: [
        {
          type: 'other',
          name: 'message.transaction.batchQuery',
          permissionCode: 'transaction:list:batchQuery',
          buttonType: 'default',
          func: () => {
            this.$refs.uploadBatchQueryModal.openModalAndCallBack((form) => {
              form.formReset();
              this.batchQuerydCondition[0].uploadRange.uploadFileList = [];
            });
          },
        },
        {
          type: 'download',
          permissionCode: 'transaction:list:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await TransitionService.downloadTransaction(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        },
        {
          type: 'other',
          name: 'message.transaction.batchRefund',
          buttonType: 'default',
          permissionCode: 'transaction:list:batchRefund',
          func: () => {
            this.$refs.uploadBatchRefundModal.openModalAndCallBack((form) => {
              form.formReset();
              this.batchRefundCondition[0].uploadRange.uploadFileList = [];
            });
          },
        },
        {
          type: 'other',
          name: 'message.transaction.uploadLogisticsNo',
          buttonType: 'default',
          permissionCode: 'transaction:list:uploadTrackingNumber',
          func: () => {
            this.$refs.uploadModal.openModalAndCallBack((form) => {
              form.formReset();
              this.uploadCondition[0].uploadRange.uploadFileList = [];
            });
          },
        },
      ],
      tableCondition: [
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnTime' },
          key: 'txnTime',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.txnCompleteTime' },
          key: 'txnCompletionTime',
          type: 'text',
        },
        {
          key: 'txnSerialNumber',
          titleBar: {
            title: 'message.tableCommon.txnSerialNumber',
            type: 'text',
            filterKey: 'txnId',
          },
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'id',
              isDisplayFunc: () => {
                return this.isHasViewAuth();
              },
              func: (data) => {
                const params = {
                  id: data.id,
                };
                // if (this.isQueryHistory) {
                //   params.isHistory = '1';
                // }
                this.$router.push({
                  path: data.txnType === '0005' ? '/transaction/refund/details' : '/transaction/details',
                  query: params,
                });
              },
            },
            {
              type: 'text',
              key: 'id',
              isDisplayFunc: () => !this.isHasViewAuth(),
            },
          ],
        },
        // 渠道响应ID
        // {
        //   titleBar: { type: 'text_tooltip', title: 'message.transaction.channelResponseId', tooltipContent: 'message.transaction.channelResponseIdTooltip' },
        //   key: 'channelTxnId',
        //   type: 'text',
        //   itemWidth: 215,
        //   showTooltip: true,
        // },
        {
          titleBar: { type: 'text', title: '' },
          key: 'retriedType',
          type: 'text',
          textFunc: (data) => ['7', '8', '9'].includes(String(data.retriedType)) ? this.$t('message.status.retry') : '',
          itemStyle: (data) => {
            return ['7', '8', '9'].includes(String(data.retriedType)) ? 'background-color: #FFEBD6;color: #FF8000;font-weight: 400;padding: 4px 10px;border-radius: 20px;' : '';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnType', filterKey: 'txnType' },
          key: 'txnType',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.txnTypeList, data.txnType),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.orderAmount' },
          // titleBar: { type: 'text', title: 'message.tableCommon.settlementCurrencyAmount' },
          key: 'txnAmount',
          type: 'text',
          textFunc: (data) => splicingAmountAndCurrency(data.txnAmount && data.txnAmount.currency, data.txnAmount && data.txnAmount.amount),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.cardType', filterKey: 'cardType' },
          key: 'cardType',
          type: 'image',
          imagePathFunc: (data) => {
            if (data.cardType && this.cardTypeLogoMap) {
              return this.cardTypeLogoMap[data.cardType];
            }
            return '';
          },
        },
        {
          titleBar: { type: 'text_tooltip', title: 'message.transaction.channelRequestId', tooltipContent: 'message.transaction.channelRequestIdTooltip' },
          key: 'channelRequestId',
          type: 'text',
          // showTooltip: true,
        },
        {
          titleBar: { type: 'text_tooltip', title: 'message.transaction.channelResponseId', tooltipContent: 'message.transaction.channelResponseIdTooltip' },
          key: 'channelTxnId',
          type: 'text',
          // itemWidth: 215,
          // showTooltip: true,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.subCardType' },
          key: 'walletTypeCode',
          type: 'text',
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnAmount' },
          key: 'settleAmount',
          type: 'text',
          textFunc: (data) => {
            if (!data.settleAmount || data.settleAmount.amount === null) {
              return '';
            }
            return splicingAmountAndCurrency(data.settleAmount && data.settleAmount.currency, data.settleAmount && data.settleAmount.amount);
          },
          itemStyle: () => {
            return 'font-family: Avenir-Heavy, Avenir;font-weight: 800;line-height: 28px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.refundSucceedAmount' },
          key: 'refundAmount',
          type: 'text',
          textFunc: (data) => {
            if (!data.refundAmount) {
              return;
            }
            return splicingAmountAndCurrency(data.refundAmount && data.refundAmount.currency, data.refundAmount && data.refundAmount.amount);
          },
          itemStyle: () => {
            return 'font-family: Avenir-Heavy, Avenir;font-weight: 800;line-height: 28px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.settlement.refuseAmount' },
          key: 'chargebackAmount',
          type: 'text',
          textFunc: (data) => {
            const list = data.chargebackAmount || [];
            if (list.length === 0) {
              return '';
            }
            const arr = list.reduce((acc, cur) => {
              acc.push(splicingAmountAndCurrency(cur && cur.currency, cur && cur.amount));
              return acc;
            }, []);
            return arr.join(';');
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.txnStatus', filterKey: 'txnStatus' },
          key: 'txnStatus',
          type: 'text',
          isInternationalization: true,
          textFunc: (data) => this.setTxnStatus(data),
          itemStyle: (data) => {
            const text = this.setTxnStatus(data);
            if (!text) { // 不存在
              return '';
            }
            if (data.txnStatus === 'S') { // 成功
              return 'padding: 0 8px;min-width: 58px;height: 27px;text-align: center;background:rgba(0,221,40,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
            } else if (data.txnStatus === 'P' || data.txnStatus === 'U' || data.txnStatus === 'R') { // 处理中、待支付、重定向
              return 'padding: 0 8px;min-width: 58px;height: 27px;text-align: center;background:rgba(255,178,9,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
            } else if (data.txnStatus === 'N') { // 取消
              return 'padding: 0 8px;min-width: 58px;height: 27px;text-align: center;background:#F1F5F7;border-radius:4px;font-weight: 800;line-height: 27px;';
            }
            return 'padding: 0 8px;min-width: 58px;height: 27px;text-align: center;background:rgba(252,100,45,0.15);border-radius:4px;font-weight: 800;line-height: 27px;';
          },
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.remark' },
          key: 'errorMsg',
          type: 'text',
        },
        {
          key: 'originalTxnSerialNumber',
          titleBar: {
            title: 'message.tableCommon.originalTxnSerialNumber',
            type: 'text',
            filterKey: 'originTxnId',
          },
          type: 'click',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'originTxnId',
              isDisplayFunc: () => {
                return this.isHasViewAuth();
              },
              func: (data) => {
                const params = {
                  id: data.originTxnId,
                };
                // if (this.isQueryHistory) {
                //   params.isHistory = '1';
                // }
                this.$router.push({
                  path: '/transaction/details',
                  query: params,
                });
              },
            },
            {
              type: 'text',
              key: 'originTxnId',
              isDisplayFunc: () => !this.isHasViewAuth(),
            },
          ],
          itemWidth: 255,
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOrderNumber' },
          key: 'merchantTxnId',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.merchantOriginalOrderNumber' },
          key: 'merchantTxnOriginalId',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.transaction.paymentStatus' },
          key: 'userPaymentStatus',
          type: 'text',
          isInternationalization: true,
          textFunc: (data) => getEnantiomericValue(UserPaymentStatus, data.userPaymentStatus),
          itemWidth: '150px',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.productType', filterKey: 'productType' },
          key: 'productType',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.productTypeList, data.productType),
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.subProductType', filterKey: 'subProductType' },
          key: 'subProductType',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.subProductTypeList, data.subProductType),
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.appId' },
          key: 'appId',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.arn' },
          key: 'arn',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.refuse.chargebackAlert' },
          key: 'chargebackWarning',
          type: 'text',
          isInternationalization: true,
          textFunc: (data) => getEnantiomericValue(ShowChargebackAlertOptions, `${data.chargebackWarning}`),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.website' },
          key: 'website',
          type: 'text',
          isItemSettingsDisplay: false,
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.bankCardNo' },
          key: 'cardNumber',
          type: 'text',
          textFunc: (data) => formatCardNumber(data.cardNumber),
        },
        {
          titleBar: { type: 'text', title: 'message.tableCommon.email' },
          key: 'email',
          type: 'text',
          itemWidth: 200,
        },
        { // 是否上传物流单号
          titleBar: { type: 'text', title: 'message.transaction.isUploadLogistics' },
          key: 'isUploadLogistics',
          type: 'text',
          itemWidth: 200,
          isInternationalization: true,
          textFunc: (row) => ((row.txnType === '0006' && row.txnStatus === 'S') ? getEnantiomericValue(UploadOptions, row.trackingNumber ? 'true' : 'false') : ''), // 只有成功Sale显示此字段
        },
        { // 是否3ds
          titleBar: { type: 'text', title: 'message.tableCommon.require3d' },
          key: 'require3d',
          type: 'text',
          itemWidth: 200,
          isInternationalization: true,
          isItemSettingsDisplay: false,
          textFunc: (row) => (getEnantiomericValue(boolSelect, row.require3d ? 'true' : 'false')), // 只有成功Sale显示此字段
        },
        { // 物流商
          titleBar: { type: 'text', title: 'message.transaction.logisticsProvider' },
          key: 'carrier',
          type: 'text',
          itemWidth: 200,
          textFunc: (row) => getEnantiomericValue(this.carrierList, row.carrier),
        },
        { // 物流单号
          titleBar: { type: 'text', title: 'message.transaction.logisticsNo' },
          key: 'trackingNumber',
          type: 'text',
          itemWidth: 200,
        },
        { // 分账状态
          titleBar: { type: 'text', title: 'message.transaction.dividendStatus' },
          key: 'shareStatus',
          type: 'text',
          itemWidth: 200,
          textFunc: (row) => getEnantiomericValue(this.shareStatusList, row.shareStatus),
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.refund',
              permissionCode: 'transaction:list:refund',
              isDisplayFunc: (data) => {
                // if (this.isQueryHistory) {
                //   return false;
                // }
                return (data.txnType === '0006' || data.txnType === '0010') && data.txnStatus === 'S' && data.txnAmount && data.txnAmount.amount > 0;
              },
              func: (data) => {
                this.$refs.refundDialogRefState.open(data.id);
              },
            },
          ],
        },
      ],
      refundCondition: [
        {
          key: 'amount',
          name: 'message.transaction.requestRefundAmount',
          type: 'editinput',
          defValue: '',
          isShowStar: true,
          rule: [REQUIRED],
        },
      ],
      uploadCondition: [
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            templateFileName: '/static/template/logisticsTrackingNumberTemplate.xlsx',
            templateFileNameShow: 'Upload_tracking_number.xlsx',
            fileTypeRule: '.xlsx',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
          },
        },
      ],
      batchQuerydCondition: [ // 批量查询
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            templateFileName: '/static/template/batchQueryTemplate.xlsx',
            templateFileNameShow: 'Batch_inquery.xlsx',
            fileTypeRule: '.xlsx',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
          },
        },
      ],
      batchRefundCondition: [
        {
          key: 'fileName',
          name: 'message.settlement.uploadFile',
          type: 'upload_file',
          defValue: '',
          isShowStar: true,
          uploadRange: {
            fileSize: 100, // 100M
            uploadFileList: [],
            templateFileName: '/static/template/batchRefundTemplate.xlsx',
            templateFileNameShow: 'Batch_refund.xlsx',
            fileTypeRule: '.xlsx',
            fileTypeRuleTips: this.$t('message.supportFileErrorTip', { type: '.xlsx' }),
            fileTypeRuleTipsShow: this.$t('message.supportFileTip', { type: 'xlsx' }),
          },
        },
      ],
      // isQueryHistory: this.$route.query.isHistory === '1',
    };
  },
  beforeCreate() {
    try {
      const menu = getCurrentMenu(this.$store.getters.permission.menus, {
        path: '/transaction',
        meta: {
          resourceCode: 'transaction:query',
        },
      });
      const index = menu.childrenNode[0].menuUrl;
      if (index !== '/transaction/query') {
        this.$router.push({ path: index });
      }
    } catch (err) {
      //
    }
  },
  mounted() {
    GlobalData.getDictList(['SUBPRODUCT_TYPE', 'PRODUCT_TYPE', 'TXN_TYPE', 'MERC_TXN_STATUS', 'CARRIER', 'SHARE', 'WALLET_TYPE_CODE']).then((res) => {
      this.txnTypeList = initSelectedData(res.TXN_TYPE);
      this.txnStatusList = initSelectedData(res.MERC_TXN_STATUS);
      this.productTypeList = initSelectedData(res.PRODUCT_TYPE);
      this.subProductTypeList = initSelectedData(res.SUBPRODUCT_TYPE);
      this.carrierList = initSelectedData(res.CARRIER);
      this.shareStatusList = initSelectedData(res.SHARE);
      this.walletTypeCodeList = initSelectedData(res.WALLET_TYPE_CODE);
      if (this.$refs.search) {
        this.$refs.search.setSearchSelectOptions('productType', this.productTypeList);
        this.$refs.search.setSearchSelectOptions('subProductType', this.subProductTypeList);
        this.$refs.search.setSearchSelectOptions('txnStatus', this.txnStatusList);
        this.$refs.search.setSearchSelectOptions('shareStatus', this.shareStatusList);
        this.$refs.search.setSearchSelectOptions('walletTypeCode', this.walletTypeCodeList);
        this.initTxnTypeSelectList();
      }
      this.initCardTypes();
    }).catch(() => {
    });
  },
  methods: {
    getInitParams() {
      const time = initDaysRangeByToday(-2);
      return {
        startTime: formatDateDisplay(time[0]),
        endTime: formatDateDisplay(time[1]),
        // isHistory: '1',
        completed: '',
      };
    },
    /**
   * 初始化卡种
   */
    initCardTypes() {
      getCardTypeList().then((data) => {
        this.cardTypeList = initSelectedData(data, 'cardType', 'cardType');
        try {
          this.cardTypeLogoMap = data.reduce((acc, cur) => {
            acc[cur.cardType] = cur.logoPath;
            return acc;
          }, {});
        } catch (err) { }
        if (this.$refs.search) {
          this.$refs.search.setSearchSelectOptions('cardType', this.cardTypeList);
        }
        this.$refs.table.firstVisitHttp();
      }).catch(() => ({}));
    },
    // 交易状态固定显示
    setTxnStatus(data) {
      if (data.txnType === '0029' && (data.txnStatus === 'P' || data.txnStatus === 'I')) {
        return 'message.status.acceptedSuccess';
      }
      return getEnantiomericValue(this.txnStatusList, data.txnStatus);
    },
    onRefreshTable() {
      return this.$refs.table.refreshTable();
    },
    getAmountDisplay(data) {
      if (data) {
        return splicingAmountAndCurrency(data.currency, data.amount);
      }
      return '';
    },
    isHasViewAuth() {
      return this.$store.getters[IS_PERMISSION_BUTTON]('transaction:list:detail');
    },
    initTxnTypeSelectList() {
      const array = shallowClones(this.txnTypeList).filter(item => {
        if (item.label === 'message.searchCommon.all' || this.txnTypeSelects.includes(item.value)) {
          return item;
        }
      });
      this.$refs.search.setSearchSelectOptions('txnType', array);
    },
    validSearchParams(params) {
      if (params.keywords) {
        return true;
      }
      if (params.email && !EMAIL.regExp.test(params.email)) {
        ShowErrorMessage(this.$t(EMAIL.tips));
        return;
      }
      if (!params.startTime && !params.endTime) {
        ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.tableCommon.txnTime') }));
        return false;
      }
      if (params.startTime || params.endTime) {
        if (!params.startTime) {
          ShowErrorMessage(this.$t('message.searchCommon.startTimeTip', { time: this.$t('message.tableCommon.txnTime') }));
          return false;
        }
        if (!params.endTime) {
          ShowErrorMessage(this.$t('message.searchCommon.endTimeTip', { time: this.$t('message.tableCommon.txnTime') }));
          return false;
        }
      }

      try {
        // this.isQueryHistory = params.isHistory === '1';
        // if (this.$refs.search) {
        //   this.$refs.search.initSearchButtons();
        // }
      } catch (err) {
        //
      }

      return true;
    },
    uploadTrackNumberFile(params) {
      if (this.uploadCondition[0].uploadRange.uploadFileList.length === 0) {
        ShowErrorMessage(this.$t('message.emptyUploadFileTip'));
        return Promise.reject(new Error(''));
      }
      return this.uploadTrackingNumber(params.fileNameFile);
    },
    uploadTrackNumberFileSuccessHandler(params) { // 跳到上传详情页面
      this.$router.push({
        path: '/content/upload',
      });
    },
    uploadBatchRefundFile(params) {
      if (this.batchRefundCondition[0].uploadRange.uploadFileList.length === 0) {
        ShowErrorMessage(this.$t('message.emptyUploadFileTip'));
        return Promise.reject(new Error(''));
      }
      return this.batchRefund(params.fileNameFile);
    },
    uploadBatchQueryFile(params) {
      if (this.batchQuerydCondition[0].uploadRange.uploadFileList.length === 0) {
        ShowErrorMessage(this.$t('message.emptyUploadFileTip'));
        return Promise.reject(new Error(''));
      }
      return this.batchQuery(params.fileNameFile);
    },
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

.transaction-search .fuzzy-input-box {
  width: 420px !important;
}

html[lang=en] .transaction-search .fuzzy-input-box {
  width: 670px !important;
}

.refund-amount-info {
  padding: 12px 14px 0;
  background-color: $color-default;
  border-radius: 2px;

  .el-descriptions__body {
    background-color: $color-default;

    .el-descriptions-item__label {
      font-size: 14px;
      line-height: 20px;
      padding-bottom: 0;
      color: $color-text-primary;
    }

    .el-descriptions-item__content {
      font-size: 14px;
      font-weight: 800;
      color: $color-text-primary;
    }
  }

  margin-bottom: 30px;
}
</style>
